import _ from 'lodash';
import IApplicationState from 'app/types/state';

function mapSelect(paymentEventImports, n) {
  const sa = paymentEventImports.paymentEventImportsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getPaymentEventImportsByIdInSelectFormat(paymentEventImports): any {
  return _.map(paymentEventImports.paymentEventImportIds, (n) => mapSelect(paymentEventImports, n));
}
export function getCurrentPaymentEventImport(state: IApplicationState): any {
  if (
    state.paymentEventImports.paymentEventImportsById !== undefined
    && state.paymentEventImports.currentPaymentEventImportId !== undefined
  ) {
    const findPaymentEventImport = state.paymentEventImports.paymentEventImportsById[state.paymentEventImports.currentPaymentEventImportId];
    const currentPaymentEventImport = {
      ...findPaymentEventImport,
    };

    return currentPaymentEventImport;
  }
  return {};
}

export function getPaymentEventImports(state: IApplicationState): any {
  return {
    ...state.paymentEventImports,
    currentPaymentEventImport: {
      ...getCurrentPaymentEventImport(state),
    },
  };
}

export function getPaymentEventImportsByTeamId(state: IApplicationState, teamId): any {
  if (state.paymentEventImports.paymentEventImportsById !== undefined && teamId != null) {
    return _.filter(state.paymentEventImports.paymentEventImportsById, { teamId });
  }
  return {};
}

export function getPaymentEventImportsByIds(paymentEventImportsById, paymentEventImportIds): any {
  if (paymentEventImportsById !== undefined && paymentEventImportIds != null) {
    return _.pick(paymentEventImportsById, paymentEventImportIds);
  }
  return {};
}

export function getPaymentEventImportIdsByTeamId(state: IApplicationState, teamId): any {
  if (state.paymentEventImports.paymentEventImportsById !== undefined && teamId != null) {
    const filtered = _.filter(state.paymentEventImports.paymentEventImportsById, { teamId });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}
